module.exports = __webpack_public_path__ + "static/media/jumbotronContact.328ef4e0.jpeg";